import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../Services/AuthContext";
import {Link, useOutletContext} from "react-router-dom";
import {
    DetailsList,
    FontWeights,
    IconButton,
    PrimaryButton,
    SelectionMode,
    SharedColors,
    TooltipHost
} from "@fluentui/react";
import {filterTasks, formatComments, modifyTask, sortColumns, taskWarning} from "../../Utilities/taskFunctions"
import {CSVDownloader} from "react-papaparse";
import AddTaskComment from "../../Panel/Task/AddTaskComment";

function TaskCurrent() {
    const [user] = useContext(AuthContext);
    const [tasks, setTasks] = useState([]);
    const [sort, setSort] = useState({key: 'created'})
    const {userFilter, searchbox} = useOutletContext();
    const [filteredTasks, setFilteredTasks] = useState([])
    const [addComment, setAddComment] = useState(false);

    const [refresh, setRefresh] = useState(0);

    const _sort = (e, col) => setSort(col);

    const taskActions = (item) => {
        return (<span>
                <IconButton iconProps={{iconName: 'History'}} onClick={() => modifyTask(item.id, 'revert', [], user, setRefresh)} />
                <IconButton iconProps={{iconName: 'CheckMark'}} onClick={() => modifyTask(item.id, 'complete', [], user, setRefresh)} />
        </span>);
    }

    const taskAssignment = (item) => {
        if (item.assigned_to === null) {
            return (
                <span>
                    <IconButton iconProps={{iconName: 'FollowUser', title: "Przypisz mnie"}} onClick={() => modifyTask(item.id, 'assign', [], user, setRefresh, 'PUT')} />
                </span>
            )
        } else {
            return (
                <span>
                    <IconButton iconProps={{iconName: 'UserRemove', title: "Usuń przypisanie"}} onClick={() => modifyTask(item.id, 'unassign', [], user, setRefresh, 'PUT')} />
                    <span title={item.assigned_to_name}>{item.assigned_to_name}</span>
                </span>
            )
        }
    }

    const taskDeadline = (item) => {
        if(item.deadline === null) { return '' }
        const diff = new Date(item.deadline).getTime() - new Date().getTime();
        const days = Math.ceil(diff / (1000 * 3600 * 24));
        let color = ''
        if (days < 4) {
            color = SharedColors.red20
        } else if (days < 9) {
            color = SharedColors.orange10
        }
        return (<span style={{color: color, fontWeight: FontWeights.semibold}}>{item.deadline}</span>)
    }

    useEffect(() => {
        const abortController = new AbortController();
        setTasks([]);
        async function fetchData() {
            await fetch(`/api/task/current`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setTasks(data.tasks);
                    // setCount(data.count);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [refresh]);


    useEffect(() => {
        sortColumns(columns, sort, setColumns, tasks, setTasks);
    }, [sort]);


    useEffect(() => {
        filterTasks(tasks, userFilter, user, searchbox, setFilteredTasks);
    }, [userFilter, tasks, searchbox]);


    const [columns, setColumns] = useState([
        {
            key: 'description',
            name: 'Opis',
            ariaLabel: 'Opis',
            fieldName: 'description',
            minWidth: 200,
            isResizable: true,
            isRowHeader: true,
            onColumnClick: _sort
        },

        {
            key: 'assigned_to',
            name: 'Przypisane do',
            ariaLabel: 'Przypisane do',
            fieldName: 'assigned_to',
            minWidth: 180,
            isResizable: true,
            onRender: taskAssignment,
        },
        {
            key: 'type',
            name: 'Typ',
            ariaLabel: 'Typ',
            fieldName: 'type',
            minWidth: 90,
            maxWidth: 150,
            isResizable: true,
            hide: true
        },
        {
            key: 'contractor',
            name: 'Wykonawca',
            ariaLabel: 'Wykonawca',
            fieldName: 'contractor',
            minWidth: 120,
            isResizable: true,
            onColumnClick: _sort,
        },
        {
            key: 'venture',
            name: 'Kontrakt',
            ariaLabel: 'Kontrakt',
            fieldName: 'venture',
            minWidth: 120,
            isResizable: true,
            onColumnClick: _sort,
        },
        {
            key: 'project',
            name: 'Projekt',
            ariaLabel: 'Projekt',
            fieldName: 'project',
            minWidth: 150,
            isResizable: true,
            isCollapsible: true,
            onColumnClick: _sort,
            onRender: (item) => (
                item.project_id !== null && (
                    <Link to={`/project/${item.project_id}`}>
                        <PrimaryButton text={item.project} />
                    </Link>
                )
            )
        },
        {
            key: 'comment',
            name: 'Komentarze',
            ariaLabel: 'Komentarze',
            fieldName: 'comment',
            minWidth: 45,
            isResizable: false,
            onRender: (item) => (<TooltipHost tooltipProps={formatComments(item)}>
                <IconButton onClick={() => setAddComment(item.id)} iconProps={{iconName: 'Comment'}}/></TooltipHost>)
        },
        {
            key: 'created',
            name: 'Utworzono',
            ariaLabel: 'Utworzono',
            fieldName: 'created',
            minWidth: 130,
            isResizable: false,
            isSorted: true,
            onRender: taskWarning,
            onColumnClick: _sort,
        },
        {
            key: 'deadline',
            name: 'Termin',
            ariaLabel: 'Termin wykonania',
            fieldName: 'deadline',
            minWidth: 130,
            isResizable: false,
            onColumnClick: _sort,
            onRender: taskDeadline,
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 130,
            maxWidth: 130,
            isResizable: true,
            onRender: taskActions
        }
    ]);
    return (
        <div>
            <DetailsList items={filteredTasks} columns={columns} selectionMode={SelectionMode.none} constrainMode={0}/>
            <CSVDownloader data={tasks} filename={`zadania`} bom={true} config={{delimiter: ';'}}><IconButton iconProps={ {iconName: 'ExcelDocument' }} title='Export CSV'/></CSVDownloader>
            <AddTaskComment onSuccess={() => setRefresh(refresh + 1)} add={addComment} dismissPanel={() => setAddComment(false)}/>
        </div>
    );
}

export default TaskCurrent